import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';
import { KeretService } from '../../keret.service';
import { DataService } from '../../data.service';
import { modeFavicon } from '../../mode-nevek';
import { TobbIntezmenyComponent } from '../tobb-intezmeny/tobb-intezmeny.component';
import { HttpClient } from '@angular/common/http';
import { fejlesztoE } from '../../jogszabalyfigyelo/fejleszto';

/**
 *  PROFIL-LENYÍLÓ a Fókusz témájú modulok fejlécében (modul-tema.ts; ma a NAPLO és a BÉR).
 *
 *  Asztali nézetben ez váltja ki a bal oldali sávot: a két kép (a felhasználó és az intézmény),
 *  a név, az intézmény- és a modulváltó, a modul témája (adminnak) és a kijelentkezés. Mobilon
 *  a bal sáv marad (a hamburger-gombbal), ezért ott ez a gomb rejtve van (a hívó layout dönti
 *  el, CSS-sel). Klasszikus témában nem jelenik meg – ott mindez a bal sávban van.
 */
@Component({
  selector: 'app-profil-menu',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TobbIntezmenyComponent],
  templateUrl: './profil-menu.component.html',
  styleUrls: ['./profil-menu.component.scss'],
})
export class ProfilMenuComponent {
  /** A gomb színvilága: sötét fejléchez világos, világoshoz sötét. */
  @Input() sotetFejlec = true;

  nyitva = false;
  esemeny: Event | null = null;
  intezmenySzuro = '';

  /** Adminisztráció: ha a jogkörszerkesztőben az aktuális modulban joga van a /admin-ra. */
  adminLathato = false;
  /** Fejlesztői (nem publikus) pont: Jogszabályfigyelő – a kiszolgáló dönti el (jogszabalyfigyelo/fejleszto.ts). */
  fejleszto = false;

  constructor(public keret: KeretService, private data: DataService, private router: Router, private http: HttpClient) {}

  get k() { return this.keret.a; }
  get intezmenyek(): any[] {
    const l = this.k?.intezmenyek() || [];
    const q = this.intezmenySzuro.trim().toLowerCase();
    return q ? l.filter((i) => String(i?.intezmenyName || '').toLowerCase().includes(q)) : l;
  }
  get osszesIntezmeny(): number { return (this.k?.intezmenyek() || []).length; }
  modIkon(kod: string) { return modeFavicon(kod); }

  nyit(ev: Event) {
    this.esemeny = ev; this.intezmenySzuro = ''; this.nyitva = true;
    this.data.hozzaferesek().then((j) => { this.adminLathato = j.szabad('/admin'); }).catch(() => { this.adminLathato = false; });
    fejlesztoE(this.http).then((f) => { this.fejleszto = f; });
  }
  admin() { this.nyitva = false; this.router.navigateByUrl('/admin'); }
  /** A saját, csak olvasható profil (profil/) – Fókuszban asztali nézetben nincs bal sáv, innen érhető el. */
  profil() { this.nyitva = false; this.router.navigateByUrl('/profil'); }
  /** A felhasználó saját beállításai (téma, menüszín) – a témaválasztó ide költözött. */
  beallitasok() { this.nyitva = false; this.router.navigateByUrl('/beallitasok'); }
  jogszabalyfigyelo() { this.nyitva = false; this.router.navigateByUrl('/jogszabalyfigyelo'); }

  intezmenyValt(i: any) {
    if (!this.k || String(i?.intezmenyId) === this.k.intezmenyId()) { this.nyitva = false; return; }
    this.nyitva = false;
    this.k.intezmenyValt(i);
  }
  modValt(m: { name: string; cim: string }) {
    if (!this.k || m.name === this.k.aktualisMod()) { this.nyitva = false; return; }
    this.nyitva = false;
    this.k.modValt(m);
  }
  kilep() { this.nyitva = false; this.k?.kilepes(); }
}
